// @flow
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import ReactDOM from 'react-dom'
import Checkbox from '@material-ui/core/Checkbox'
import Divider from '@material-ui/core/Divider'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import IconButton from '@material-ui/core/IconButton'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import LayerStyles from 'catena/er2_styles/layers'
import LayerProperties from './layer_properties'
import type { MapType } from '../reducers/map'

type PropTypes = {
    name: string,
    visible: boolean,
    classifyField: string,
    classifyType: string,
    classifications: Array<{
        size: number,
    }>,
    crs: {
        init: string,
    },
    datatype: string,
    er2map: any,
    getLayerClassifications: Function,
    layer_type: string,
    legendURL: string,
    map: MapType,
    mapsource: string,
    onChangeClassifications: Function,
    onChangeProps: Function,
    onDelete: Function,
    onDownload: Function,
    onGetAttributes: Function,
    onQuery: Function,
    onZoom: Function,
    proj4: string,
    row_count: number,
    theme: LayerStyles,
}

class Layer extends React.Component<PropTypes> {
    constructor(props) {
        super(props)
        this.state = {
            classifyType: 'Single Symbol',
            displayDownloader: false,
            displayProps: false,
            editName: null,
            expanded: false,
            minColor: '#FF0000',
            maxColor: '#0000FF',
            nclass: 5,
            visible: true,
            spaceForName: 0,
            ...props,
        }
    }

    onRename = () => {
        this.setState({
            editName: this.state.name,
        })
    }

    onBlurName = () => {
        this.props.onChangeProps({ name: this.state.editName })
        this.setState({
            editName: null,
        })
    }

    onChangeName = (e) => {
        this.setState({
            editName: e.target.value,
        })
    }

    setFocus = e => e.target.select()

    render() {
        const showProps = () => {
            this.setState({ displayProps: !this.state.displayProps })
        }
        const onDelete = (e) => {
            this.props.onDelete(e)
            e.stopPropagation()
        }
        const onDownload = (e) => {
            this.setState({ displayDownloader: true })
            this.props.onDownload(e)
            e.stopPropagation()
        }
        const onZoom = (e) => {
            this.props.onZoom(e)
            e.stopPropagation()
        }
        const changeVisibility = (e) => {
            this.props.onChangeProps({ visible: e.target.checked })
            this.setState({ visible: e.target.checked })
            e.stopPropagation()
        }
        const expansionPanelClick = (event, expanded) => {
            this.setState({ expanded })
        }
        const stopPropagation = e => e.stopPropagation()

        let layerprops = null
        if (this.state.displayProps) {
            const updateLayerProperties = (layerProps) => {
                this.props.onChangeProps(layerProps)
            }
            const { top, left } = this.ref.getBoundingClientRect()
            const root = document.getElementById('root')
            layerprops = ReactDOM.createPortal((
                <LayerProperties
                    layerProps={this.props}
                    map={this.props.map}
                    onChangeClassifications={this.props.onChangeClassifications}
                    onChangeProps={updateLayerProperties}
                    onClose={() => this.setState({ displayProps: false })}
                    pos={{ top, right: root.getBoundingClientRect().right - left }}
                    getLayerClassifications={this.props.getLayerClassifications}
                    theme={this.props.theme}
                />
            ), root)
        }

        const getLayerDetails = () => {
            if (this.props.layer_type.toLowerCase() === 'raster') {
                return (
                    <div>
                        <div><span className={this.props.theme.layerOverviewLabel}>Feature Type:</span><span className={this.props.theme.layerOverviewItem}>{this.props.layer_type}</span></div>
                        <div><span className={this.props.theme.layerOverviewLabel}>Projection:</span><span className={this.props.theme.layerOverviewItem}>{this.props.proj4}</span></div>
                        <div><span className={this.props.theme.layerOverviewLabel}>Raster Type:</span><span className={this.props.theme.layerOverviewItem}>{this.props.datatype}</span></div>
                    </div>
                )
            }
            return (
                <div>
                    <div><span className={this.props.theme.layerOverviewLabel}>Feature</span><span className={this.props.theme.layerOverviewItem}>{this.props.layer_type}</span></div>
                    <div><span className={this.props.theme.layerOverviewLabel}>Feature Count</span><span className={this.props.theme.layerOverviewItem}>{this.props.row_count}</span></div>
                    <div><span className={this.props.theme.layerOverviewLabel}>Projection</span><span className={this.props.theme.layerOverviewItem}>{this.props.crs ? this.props.crs.init : '-'}</span></div>
                    <div><span className={this.props.theme.layerOverviewLabel}>Classification</span><span className={this.props.theme.layerOverviewItem}>{this.props.classifyType}</span></div>
                    {this.props.classifyField && (<div><span className={this.props.theme.layerOverviewLabel}>Field</span><span className={this.props.theme.layerOverviewItem}>{this.props.classifyField}</span></div>)}
                </div>
            )
        }

        return (
            <div ref={(el) => { this.ref = el }}>
                <div
                    className={this.props.theme.layerPropsDiv}
                >
                    {layerprops}
                </div>
                <ExpansionPanel
                    classes={{
                        expanded: this.props.theme.panelExpanded,
                    }}
                    className={this.props.theme.panel}
                    onChange={expansionPanelClick}
                    style={{ backgroundColor: this.state.displayProps ? 'rgba(227, 234, 237)' : 'white' }}
                >
                    <ExpansionPanelSummary
                        classes={{
                            content: `${this.props.theme.panelSummary} ${this.state.expanded ? this.props.theme.panelClicked : ''}`,
                            expandIcon: this.props.theme.expandButton,
                        }}
                        className={this.props.theme.panelSummary}
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <FormControl>
                            <Checkbox
                                color="secondary"
                                classes={{
                                    root: this.props.theme.panelSwitch,
                                }}
                                checked={this.state.visible ? 'checked' : ''}
                                onChange={changeVisibility}
                                onClick={stopPropagation}
                            />
                        </FormControl>
                        {this.state.editName ? (
                            <TextField
                                autoFocus
                                value={this.state.editName}
                                onChange={this.onChangeName}
                                onBlur={this.onBlurName}
                                onFocus={this.setFocus}
                                onKeyDown={(ev) => {
                                    if (ev.key === 'Enter') {
                                        // Do code here
                                        this.onBlurName(ev)
                                        ev.preventDefault()
                                    } else if (ev.key === 'Escape') {
                                        this.setState({ editName: null })
                                        ev.preventDefault()
                                    }
                                }}
                            />
                        ) : (
                            <Typography
                                className={this.props.theme.layerLabel}
                            >
                                {this.props.name}
                            </Typography>
                        )}
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails
                        className={this.props.theme.panelDetails}
                    >
                        <div className={this.props.theme.table}>
                            <div className={this.props.theme.layerRow}>
                                <IconButton
                                    onClick={showProps}
                                    className={this.props.theme.littleButton}
                                    title="Show Attributes"
                                >
                                    <i className={'fa fa-window-restore'} role="button" />
                                </IconButton>
                                <IconButton
                                    onClick={onZoom}
                                    className={this.props.theme.littleButton}
                                    title="Zoom to Layer"
                                >
                                    <i className={'fa fa-search'} role="button" />
                                </IconButton>
                                {this.props.layer_type !== 'RASTER' && (
                                    <span>
                                        <IconButton
                                            onClick={this.props.onGetAttributes}
                                            className={this.props.theme.littleButton}
                                            title="Open Attribute Table"
                                        >
                                            <i className={'fa fa-table'} role="button" />
                                        </IconButton>
                                        <IconButton
                                            onClick={this.props.onQuery}
                                            className={this.props.theme.littleButton}
                                            title="Query (Advanced Search)"
                                        >
                                            <i className="fa fa-object-group" />
                                        </IconButton>
                                    </span>
                                )}
                                <IconButton
                                    onClick={onDownload}
                                    className={this.props.theme.littleButton}
                                    title="Download"
                                >
                                    <i className={'fa fa-download'} role="button" />
                                </IconButton>
                                <IconButton
                                    onClick={onDelete}
                                    className={this.props.theme.littleButton}
                                    title="Delete"
                                >
                                    <i className={'fa fa-trash'} role="button" />
                                </IconButton>
                                <IconButton
                                    onClick={this.onRename}
                                    className={this.props.theme.littleButton}
                                    title="Rename"
                                >
                                    <i className={'fa fa-pencil'} role="button" />
                                </IconButton>
                            </div>
                            <Divider />
                        </div>
                        <div className={this.props.theme.table}>
                            <div className={this.props.theme.row}>
                                <div
                                    role="button"
                                    className={this.props.theme.column}
                                    onClick={showProps}
                                    tabIndex={-1}
                                >
                                    <div className={this.props.theme.legend}>
                                        <img
                                            src={this.props.legendURL}
                                            alt="legend"
                                        />
                                    </div>
                                </div>
                                <div
                                    className={this.props.theme.columnBorder}
                                    style={{ borderLeft: `1px solid ${this.state.displayProps ? '#aaa' : '#ccc'}` }}
                                >
                                    {getLayerDetails()}
                                </div>
                            </div>
                        </div>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </div>
        )
    }
}

export default Layer
